import theme from 'utils/theme';

export default value => `${value * theme.scale}rem`;
